import React from 'react';
import PaymentSuccess from '../../../Components/UserComponents/PaymentSucess';

const PaymentSuccessContainer = () => {
  return <PaymentSuccess />;
};

export default PaymentSuccessContainer;
